export function getPreview(fileId: string) {
    return `${process.env.VUE_APP_ATTACHMENT_BASE_URL}/files/${fileId}/preview`
}

export function generateAcceptString(fileTypes: Array<string>) {
    const mimeTypes = {
        heic: 'image/heic',
        jfif: 'image/jpeg',
        jpeg: 'image/jpeg',
        jpg: 'image/jpeg',
        png: 'image/png',
        svg: 'image/svg+xml',
        svgz: 'image/svg+xml',
        webp: 'image/webp',
        pdf: 'application/pdf',
        mp3: 'audio/mpeg',
        wav: 'audio/wav',
        ogg: 'audio/ogg',
        flac: 'audio/flac',
        mp4: 'video/mp4',
        mov: 'video/quicktime',
        avi: 'video/x-msvideo',
        mkv: 'video/x-matroska',
        webm: 'video/webm',
        gif: 'image/gif',
        bmp: 'image/bmp',
        tiff: 'image/tiff',
        zip: 'application/zip',
        rar: 'application/x-rar-compressed',
        txt: 'text/plain',
        json: 'application/json',
        csv: 'text/csv',
        xml: 'application/xml',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ppt: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        odt: 'application/vnd.oasis.opendocument.text',
        ods: 'application/vnd.oasis.opendocument.spreadsheet',
    }

    const acceptArray = [] as Array<string>

    fileTypes.forEach((type) => {
        type = type.toLowerCase()
        if (type in mimeTypes) {
            const mimeType = mimeTypes[type as keyof typeof mimeTypes]
            if (mimeType) {
                acceptArray.push(mimeType)
                acceptArray.push(`.${type}`)
            }
        }
    })

    // Join and return the accept string
    return acceptArray
}
